export const formatPrice = (price: number) => {
  return new Intl.NumberFormat('en-US').format(price);
};

export const formatWeight = (gram: number | string, dictionary: any) => {
  const g = Number(gram);
  if (!g || g < 1000) return g ? g + ' ' + dictionary.forms.gram : '';

  const kg = Math.floor(g / 1000);
  const rest = g % 1000;

  if (rest === 0) return kg + ' ' + dictionary.forms.kilogram;
  return `${kg} ${dictionary.forms.kilogram} و ${rest} ${dictionary.forms.gram}`;
};
